import * as Styled from "./Footer.styled";
import { S } from "../../styles/components/Text";

const Footer = () => {
    return <Styled.Footer>© Thu Le Photography</Styled.Footer>;
};

export default Footer;
